import {Box, EyebrowText, SectionIntro} from '@primer/react-brand/esm'
import type {Document} from '@contentful/rich-text-types'

import {renderWithoutParagraphs} from '../../../utils'

type PricingSectionIntroProps = {
  label?: string
  heading?: Document
  description?: Document
  hasOptions?: boolean
}

export function PricingSectionIntro({label, heading, description, hasOptions}: PricingSectionIntroProps) {
  return (
    <Box
      paddingBlockEnd={{
        narrow: hasOptions ? 'none' : 'spacious',
        regular: hasOptions ? 'none' : 64,
      }}
      paddingBlockStart={{
        narrow: 'spacious',
        regular: 64,
      }}
    >
      <SectionIntro align="center" fullWidth>
        {label && (
          <EyebrowText>
            <span style={{display: 'inline-flex', alignItems: 'center', gap: '0.25em'}}>
              {label}
              <span
                aria-hidden="true"
                style={{
                  width: 'var(--base-size-8)',
                  height: '1cap',
                  backgroundColor: 'var(--brand-color-success-fg)',
                }}
              />
            </span>
          </EyebrowText>
        )}
        {heading && <SectionIntro.Heading size="3">{renderWithoutParagraphs(heading)}</SectionIntro.Heading>}
        {description && <SectionIntro.Description>{renderWithoutParagraphs(description)}</SectionIntro.Description>}
      </SectionIntro>
    </Box>
  )
}
